import InputGroup from "../form/InputGroup";
import React, {useEffect, useState} from "react";
import {Button, Checkbox, Radio, RadioGroup, TextInput} from "omoplay";
import SuspensePopup from "../SuspensePopup";
import BenefitForm from "../form/benefit/BenefitForm";
import {getConfig, saveConfig} from "../../api/point/point.api";
import {getBenefit} from "../../api/benefit/benefit.api";
import EntryPointPreviewPopup from "../form/entrypoint/EntryPointPreviewPopup";

export const VIPForm = ({initName, initTotalPoint, initNumPoint, initRate, initUsed, onChangeName, onChangeTotalPoint, onChangeNumPoint, onChangeRate, onChangeUsed}) => {
    const [name, setName] = useState(initName)
    const [totalPoint, setTotalPoint] = useState(initTotalPoint)
    const [numPoint, setNumPoint] = useState(initNumPoint)
    const [rate, setRate] = useState(initRate)
    const [used, setUsed] = useState(initUsed)

    return (
        <div className="flex-col gap-2">
            <div className="border-t"></div>
            <div className="flex-align-center gap-2">
                <div>
                    <Checkbox item={{label: "사용", value: "used"}} checked={used ?? true}
                              onChecked={(checked) => {
                                  setUsed(checked)
                                  onChangeUsed(checked)
                              }} />
                </div>
                <div className="text-[18px] font-medium text-primary">
                    <TextInput value={name}
                               onChange={(e) => {
                                   setName(e.target.value)
                                   onChangeName(e.target.value)
                               }}
                    />
                </div>
            </div>
            <div className="flex-align-center gap-2 ml-4">
                <div>총 획득 포인트</div>
                <div className="w-[100px]">
                    <TextInput type="number" value={totalPoint}
                               onChange={(e) => {
                                   setTotalPoint(e.target.value)
                                   onChangeTotalPoint(e.target.value)
                               }}
                    />
                </div>
                <div>포인트 이상</div>
                <div className="text-primary font-semibold">AND</div>
                <div>총 적립 횟수</div>
                <div className="w-[100px]">
                    <TextInput type="number" value={numPoint}
                               onChange={(e) => {
                                   setNumPoint(e.target.value)
                                   onChangeNumPoint(e.target.value)
                               }}
                    />
                </div>
                <div>회 이상</div>
            </div>
            <div className="flex-align-center gap-2 ml-4">
                <div>적립율</div>
                <div className="w-[100px]">
                    <TextInput type="number" value={rate}
                               onChange={(e) => {
                                   setRate(e.target.value)
                                   onChangeRate(e.target.value)
                               }}
                    />
                </div>
                <div>%</div>
            </div>
        </div>
    )
}

const PointConfiguration = () => {
    /*
      기본 적립 포인트 — **방식마다 입력값을 따로 들고 있는다** (2026-08-26 개편).

      종전에는 `defaultPoint` 하나를 라디오 두 개가 공유하고 단위 표시(%/포인트)만 바뀌었다. 그래서
        ⓐ '적립율 3' 을 넣어둔 채 '고정 포인트' 로 바꾸면 그 3 이 그대로 '3 포인트' 가 되고
        ⓑ 화면만 봐서는 그 숫자가 어느 방식의 값인지 알 수 없었다.
      서버는 `pointType` 에 따라 `rate` / `static_point` 중 **하나만 쓰고 나머지는 null 로 지운다**
      (`PointController.configPoint`) → 채널은 둘 중 하나만 갖는다. 그 사실을 화면에도 드러낸다.
      저장할 때는 선택된 쪽 값만 `defaultPoint` 로 보내므로 **API 형태는 그대로다.**
    */
    const [rateInput, setRateInput] = useState("")
    const [staticPointInput, setStaticPointInput] = useState("")
    const [isOpenBenefitPopup, setOpenBenefitPopup] = useState(false)
    const [selectedBenefitId, setSelectedBenefitId] = useState(null)
    const [selectedBenefitName, setSelectedBenefitName] = useState(null)
    const [isNew, setIsNew] = useState(false)
    const [minPoint, setMinPoint] = useState(1000)
    const [maxPoint, setMaxPoint] = useState()
    const [eventPoint, setEventPoint] = useState(null)
    const [usedEventPoint, setUsedEventPoint] = useState(null)
    const [pointType, setPointType] = useState("rate")
    // omoplay `Radio` 강제 리마운트용 카운터 — 이유는 '기본 적립 포인트 설정' 블록 주석 참고.
    const [radioKey, setRadioKey] = useState(0)
    const selectPointType = (value) => {
        setPointType(value)
        setRadioKey((k) => k + 1)
    }

    const [vipConfig, setVipConfig] = useState({
        bronze: {
            name: "Bronze",
            used: true,
            totalPoint: 3000,
            numPoint: 3,
            rate: 3.0
        },
        silver: {
            name: "Silver",
            used: true,
            totalPoint: 5000,
            numPoint: 5,
            rate: 3.2
        },
        gold: {
            name: "Gold",
            used: true,
            totalPoint: 10000,
            numPoint: 10,
            rate: 3.4
        },
        platinum: {
            name: "Platinum",
            used: true,
            totalPoint: 50000,
            numPoint: 50,
            rate: 3.6
        },
        vip: {
            name: "VIP",
            used: true,
            totalPoint: 100000,
            numPoint: 100,
            rate: 3.8
        },
        vvip: {
            name: "VVIP",
            used: true,
            totalPoint: 300000,
            numPoint: 300,
            rate: 4.0
        }
    })
    const [usedVipConfig, setUsedVipConfig] = useState(false)
    const [usedExpiredMonth, setUsedExpiredMonth] = useState(false)
    const [expiredMonth, setExpiredMonth] = useState(null)
    const [entryPoints, setEntryPoints] = useState([])
    const [selectedEntryPointId, setSelectedEntryPointId] = useState(null)
    const [showQrPreview, setShowQrPreview] = useState(false)

    useEffect(() => {
        getConfig().then(({data}) => {
            if (data != null) {
                // 두 입력창을 각자 채운다. 서버는 한쪽만 값을 갖고 다른 쪽은 null 이다.
                setRateInput(data.rate ?? "")
                setStaticPointInput(data.staticPoint ?? "")
                setMinPoint(data.minPoint)
                setMaxPoint(data.maxPoint)
                setEventPoint(data.eventPoint)
                setUsedEventPoint(data.eventPoint != null)
                setUsedVipConfig(data.usedVipConfig)
                setVipConfig(data.vipConfig ?? vipConfig)
                setExpiredMonth(data.expiredMonth)
                setUsedExpiredMonth(data.expiredMonth != null)
                setIsNew(false)
                setPointType(data.rate == null ? "static" : "rate")
                setEntryPoints(data.entryPoints)
            } else {
                setIsNew(true)
            }
        })
    }, []);

    useEffect(() => {
        if (selectedBenefitId) {
            getBenefit(selectedBenefitId).then(({data}) => {
                setSelectedBenefitName(data.name)
            })
        }
    }, [selectedBenefitId]);

    /*
      등급 설정 경고 (2026-08-27 신설)

      🔴 **저장을 막지 않는다.** 최종 동작은 "사용자가 세팅한 대로" 가 맞다는 판단이다(사용자 결정).
         다만 **의도와 다르게 동작하게 되는 설정**은 이 화면에서 알려주는 것이 맞다 —
         적립 시점에는 이미 늦고, 매장 화면에서는 왜 이런 값이 나오는지 알 수 없다.

      서버 판정 규칙(`PointHistoryService.resolveEarnRate` → `PointConfig.VIPConfig.getRateByCondition`)
      을 기준으로, 그 규칙과 관리자의 의도가 갈라지는 4가지를 잡는다.
       ① '기본 적립 포인트 설정' 이 **고정 포인트**면 등급 적립율은 **아예 적용되지 않는다**
          (서버가 `defaultRate == null` 분기에서 결제 금액을 보지 않고 `static_point` 를 적립한다)
       ② 등급 적립율이 **기본 적립율보다 낮거나 같음** → 그 등급이 되어도 적립이 늘지 않는다
          (등급 조건을 만족하면 등급율이 최우선으로 적용되므로 **오히려 손해**가 된다)
       ③ **적립율 역전** — 상위 등급 적립율이 하위 등급보다 낮거나 같음
       ④ **승급 조건 역전** — 상위 등급이 하위 등급보다 먼저(또는 동시에) 달성됨

      🔧 서버는 **자격을 갖춘 등급 중 서열이 가장 높은 것**을 적용한다
         (`getRateByCondition` = `lastOrNull`, 2026-08-27 변경). 적립율이 역전되어 있으면
         상위 등급이 될 때 **적립율이 실제로 떨어진다** — 그게 설정한 대로의 동작이므로
         막지 않고, 대신 여기서 분명히 알린다.
    */
    const GRADE_ORDER = ["bronze", "silver", "gold", "platinum", "vip", "vvip"]

    const gradeWarnings = (() => {
        if (!usedVipConfig) return []

        const warnings = []
        const num = (v) => (v === "" || v == null ? NaN : Number(v))

        if (pointType === "static") {
            warnings.push("'기본 적립 포인트 설정'이 '고정 포인트'입니다. 이 경우 결제 금액과 무관하게 고정 포인트가 적립되므로 등급별 적립율이 적용되지 않습니다. 등급을 쓰려면 '적립율'로 설정해주세요.")
        }

        // 사용 중인 등급만, 설정 화면에 놓인 순서(하위 → 상위)대로
        const tiers = GRADE_ORDER
            .map((key) => ({ key, ...(vipConfig?.[key] ?? {}) }))
            .filter((t) => (t.used ?? true))

        const baseRate = num(rateInput)

        tiers.forEach((t) => {
            const r = num(t.rate)
            if (Number.isNaN(r)) {
                warnings.push(`'${t.name}' 등급의 적립율이 비어 있습니다.`)
                return
            }
            if (pointType === "rate" && !Number.isNaN(baseRate) && r <= baseRate) {
                warnings.push(`'${t.name}' 적립율 ${r}%가 '기본 적립 포인트 설정' ${baseRate}%보다 낮거나 같습니다. 이 등급이 되면 적립이 늘지 않습니다.`)
            }
        })

        for (let i = 1; i < tiers.length; i++) {
            const lower = tiers[i - 1]
            const upper = tiers[i]

            // ③ 적립율 역전 — 서버는 자격을 갖춘 **최상위 등급**의 적립율을 그대로 적용하므로
            //    상위 등급이 될 때 오히려 적립율이 떨어진다. 의도한 설정일 수도 있어 경고만 한다.
            if (num(upper.rate) <= num(lower.rate)) {
                warnings.push(`'${upper.name}' 적립율 ${upper.rate}%가 하위 등급 '${lower.name}' ${lower.rate}%보다 낮거나 같습니다. '${upper.name}'이 되면 적립율이 낮아집니다.`)
            }

            // ④ 승급 조건 역전 — 정도에 따라 문구를 나눈다.
            const upTotal = num(upper.totalPoint), loTotal = num(lower.totalPoint)
            const upNum = num(upper.numPoint), loNum = num(lower.numPoint)

            if (upTotal <= loTotal && upNum <= loNum) {
                // 완전 역전: 상위 등급이 하위 등급과 동시에(또는 먼저) 달성된다 → 하위 등급이 의미를 잃는다
                warnings.push(`'${upper.name}' 승급 조건이 하위 등급 '${lower.name}'보다 낮거나 같습니다. '${lower.name}' 등급이 적용될 일이 없습니다.`)
            } else if (upTotal < loTotal || upNum < loNum) {
                // 부분 역전: 한쪽 기준만 더 낮다 → 하위 등급을 건너뛰고 상위가 될 수 있다
                warnings.push(`'${upper.name}' 승급 조건 중 일부가 하위 등급 '${lower.name}'보다 낮습니다. '${lower.name}'을 건너뛰고 '${upper.name}'이 될 수 있습니다.`)
            }
        }

        return warnings
    })()

    return (
        <>
            <div className="flex-col gap-[36px] max-w-[1200px]">
                <div className="flex-col gap-2">
                    <InputGroup label="신규 적립 이벤트" description="신규 적립을 할 때 이벤트 진행 여부입니다.">
                        <div className="flex-align-center gap-4">
                            <div className="text-[24px] text-primary">{selectedBenefitName}</div>
                            {
                                isNew
                                    ? (<Button variants="primary" value="혜택 연결" onClick={() => setOpenBenefitPopup(true)} />)
                                    : (<div>
                                        <div className="text-red-500 mb-2">* 사용시 적립 이벤트가 진행되며 마케팅 수신동의와 친구추가 여부를 확인합니다.</div>
                                        <div className="flex-align-center gap-2">
                                            <RadioGroup items={[{label: "미사용", value: "unused"}, {label: "사용", value: "used"}]}
                                                        key={usedEventPoint}
                                                        initChecked={usedEventPoint ? "used" : "unused"}
                                                        onSelected={(value) => {
                                                            setUsedEventPoint(value === "used")
                                                        }} />
                                            {
                                                usedEventPoint && (
                                                    <>
                                                        <div className="text-primary">
                                                            신규 적립 시 제공할 포인트
                                                        </div>
                                                        <TextInput type="number" value={eventPoint}
                                                                   onChange={(e) => setEventPoint(e.target.value)}
                                                        />
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>)
                            }
                        </div>
                    </InputGroup>
                    <InputGroup label="포인트 적립 QR" description="고객이 적립할 때 사용하는 QR입니다.">
                        {
                            isNew ? (<div></div>) : (
                                <div className="flex gap-4 flex-wrap">
                                    {
                                        entryPoints.map((entryPoint) => (
                                            <div className="flex-align-center flex-col gap-2" key={entryPoint.id}>
                                                <img className="pointer" src={entryPoint.imageUrl} alt="적립 QR 이미지" width={128} height={128} onClick={() => {
                                                    setShowQrPreview(true)
                                                    setSelectedEntryPointId(entryPoint.id)
                                                }} />
                                                <div className="text-primary">{entryPoint.name}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            )
                        }
                    </InputGroup>
                    <InputGroup label="기본 적립 포인트 설정"
                                description="등급이 없는 일반 고객의 적립을 설정합니다. 두 방식 중 하나만 적용됩니다.">
                        {/*
                          🔧 **라디오를 항목명 앞에 둔다** (2026-08-26 사용자 지적).
                             종전에는 상단에 가로 라디오 그룹이 있고 그 아래에 같은 항목이 위아래로 또
                             반복되어, 무엇을 고르는 것인지가 두 번 나왔다.
                             지금은 각 행의 맨 앞 라디오가 곧 선택이고, 그 줄에 입력창·단위·설명이 붙는다.

                          ⚠️ omoplay `Radio` 는 `select` 를 내부 state 로 복사하고 클릭 시 스스로 토글한다.
                             **이미 선택된 라디오를 다시 누르면** 내부 state 가 false 로 뒤집히는데
                             `select` 값은 그대로여서 동기화 effect(`[propsSelect]`)가 다시 돌지 않아
                             화면상 해제된 채로 남는다.
                             ⇒ 선택할 때마다 바뀌는 `radioKey` 로 **강제 리마운트**해 `select` 를 다시 읽게 한다.
                        */}
                        <div className="flex-col gap-3">
                            <div className="flex-align-center gap-2">
                                <div className="w-[130px]">
                                    <Radio key={`rate-${radioKey}`} label="적립율" value="rate"
                                           select={pointType === "rate"} onSelected={selectPointType} />
                                </div>
                                <div className="w-[100px]">
                                    <TextInput type="number" value={rateInput}
                                               disabled={pointType !== "rate"}
                                               onChange={(e) => setRateInput(e.target.value)}
                                    />
                                </div>
                                <div className={pointType === "rate" ? "" : "text-tertiary"}>%</div>
                                <div className="text-tertiary text-[13px]">결제 금액의 비율만큼 적립합니다.</div>
                            </div>
                            <div className="flex-align-center gap-2">
                                <div className="w-[130px]">
                                    <Radio key={`static-${radioKey}`} label="고정 포인트" value="static"
                                           select={pointType === "static"} onSelected={selectPointType} />
                                </div>
                                <div className="w-[100px]">
                                    <TextInput type="number" value={staticPointInput}
                                               disabled={pointType !== "static"}
                                               onChange={(e) => setStaticPointInput(e.target.value)}
                                    />
                                </div>
                                <div className={pointType === "static" ? "" : "text-tertiary"}>포인트</div>
                                <div className="text-tertiary text-[13px]">결제 금액과 무관하게 항상 같은 포인트를 적립합니다. 매장 화면에서 금액을 입력할 수 없습니다.</div>
                            </div>
                        </div>
                    </InputGroup>
                    <InputGroup label="등급 관리"
                                description="조건을 모두 만족하면 자동으로 등급이 올라갑니다. 등급 조건을 만족하면 등급 적립율이 우선 적용되고, 어느 등급 조건도 만족하지 못하면 위 '기본 적립 포인트 설정'이 적용됩니다.">
                        <div className="flex-col gap-4">
                            <RadioGroup items={[{label: "미사용", value: "unused"}, {label: "사용", value: "used"}]}
                                        key={usedVipConfig}
                                        initChecked={usedVipConfig ? "used" : "unused"}
                                        onSelected={(value) => {
                                            setUsedVipConfig(value === "used")
                                        }} />
                            {/* 설정 경고 — 저장은 막지 않는다. 판단 근거는 `gradeWarnings` 주석 참고 */}
                            {gradeWarnings.length > 0 && (
                                <div className="flex-col gap-1 p-3 rounded-lg border border-amber-300 bg-amber-50">
                                    <div className="font-semibold text-amber-700">확인이 필요한 설정</div>
                                    <ul className="flex-col gap-1">
                                        {gradeWarnings.map((w) => (
                                            <li key={w} className="text-[13px] text-amber-700">· {w}</li>
                                        ))}
                                    </ul>
                                    <div className="text-[12px] text-tertiary mt-1">
                                        저장은 가능합니다. 설정한 대로 적립됩니다.
                                    </div>
                                </div>
                            )}
                            {
                                usedVipConfig && (
                                    <div className="flex-col gap-2">
                                        <VIPForm initName={vipConfig?.bronze.name}
                                                 initTotalPoint={vipConfig?.bronze.totalPoint}
                                                 initNumPoint={vipConfig?.bronze.numPoint}
                                                 initRate={vipConfig?.bronze.rate}
                                                 initUsed={vipConfig?.bronze.used}
                                                 onChangeTotalPoint={(totalPoint) =>
                                                     setVipConfig({...vipConfig, bronze: {...vipConfig.bronze, totalPoint}})}
                                                 onChangeNumPoint={(numPoint) =>
                                                     setVipConfig({...vipConfig, bronze: {...vipConfig.bronze, numPoint}})}
                                                 onChangeRate={(rate) =>
                                                     setVipConfig({...vipConfig, bronze: {...vipConfig.bronze, rate}})}
                                                 onChangeUsed={(used) =>
                                                     setVipConfig({...vipConfig, bronze: {...vipConfig.bronze, used}})}
                                                 onChangeName={(name) =>
                                                     setVipConfig({...vipConfig, bronze: {...vipConfig.bronze, name}})}
                                        />
                                        <VIPForm initName={vipConfig?.silver.name}
                                                 initTotalPoint={vipConfig?.silver.totalPoint}
                                                 initNumPoint={vipConfig?.silver.numPoint}
                                                 initRate={vipConfig?.silver.rate}
                                                 initUsed={vipConfig?.silver.used}
                                                 onChangeTotalPoint={(totalPoint) =>
                                                     setVipConfig({...vipConfig, silver: {...vipConfig.silver, totalPoint}})}
                                                 onChangeNumPoint={(numPoint) =>
                                                     setVipConfig({...vipConfig, silver: {...vipConfig.silver, numPoint}})}
                                                 onChangeRate={(rate) =>
                                                     setVipConfig({...vipConfig, silver: {...vipConfig.silver, rate}})}
                                                 onChangeUsed={(used) =>
                                                     setVipConfig({...vipConfig, silver: {...vipConfig.silver, used}})}
                                                 onChangeName={(name) =>
                                                     setVipConfig({...vipConfig, silver: {...vipConfig.silver, name}})}
                                        />
                                        <VIPForm initName={vipConfig?.gold.name}
                                                 initTotalPoint={vipConfig?.gold.totalPoint}
                                                 initNumPoint={vipConfig?.gold.numPoint}
                                                 initRate={vipConfig?.gold.rate}
                                                 initUsed={vipConfig?.gold.used}
                                                 onChangeTotalPoint={(totalPoint) =>
                                                     setVipConfig({...vipConfig, gold: {...vipConfig.gold, totalPoint}})}
                                                 onChangeNumPoint={(numPoint) =>
                                                     setVipConfig({...vipConfig, gold: {...vipConfig.gold, numPoint}})}
                                                 onChangeRate={(rate) =>
                                                     setVipConfig({...vipConfig, gold: {...vipConfig.gold, rate}})}
                                                 onChangeUsed={(used) =>
                                                     setVipConfig({...vipConfig, gold: {...vipConfig.gold, used}})}
                                                 onChangeName={(name) =>
                                                     setVipConfig({...vipConfig, gold: {...vipConfig.gold, name}})}
                                        />
                                        <VIPForm initName={vipConfig?.platinum.name}
                                                 initTotalPoint={vipConfig?.platinum.totalPoint}
                                                 initNumPoint={vipConfig?.platinum.numPoint}
                                                 initRate={vipConfig?.platinum.rate}
                                                 initUsed={vipConfig?.platinum.used}
                                                 onChangeTotalPoint={(totalPoint) =>
                                                     setVipConfig({...vipConfig, platinum: {...vipConfig.platinum, totalPoint}})}
                                                 onChangeNumPoint={(numPoint) =>
                                                     setVipConfig({...vipConfig, platinum: {...vipConfig.platinum, numPoint}})}
                                                 onChangeRate={(rate) =>
                                                     setVipConfig({...vipConfig, platinum: {...vipConfig.platinum, rate}})}
                                                 onChangeUsed={(used) =>
                                                     setVipConfig({...vipConfig, platinum: {...vipConfig.platinum, used}})}
                                                 onChangeName={(name) =>
                                                     setVipConfig({...vipConfig, platinum: {...vipConfig.platinum, name}})}
                                        />
                                        <VIPForm initName={vipConfig?.vip.name}
                                                 initTotalPoint={vipConfig?.vip.totalPoint}
                                                 initNumPoint={vipConfig?.vip.numPoint}
                                                 initRate={vipConfig?.vip.rate}
                                                 initUsed={vipConfig?.vip.used}
                                                 onChangeTotalPoint={(totalPoint) =>
                                                     setVipConfig({...vipConfig, vip: {...vipConfig.vip, totalPoint}})}
                                                 onChangeNumPoint={(numPoint) =>
                                                     setVipConfig({...vipConfig, vip: {...vipConfig.vip, numPoint}})}
                                                 onChangeRate={(rate) =>
                                                     setVipConfig({...vipConfig, vip: {...vipConfig.vip, rate}})}
                                                 onChangeUsed={(used) =>
                                                     setVipConfig({...vipConfig, vip: {...vipConfig.vip, used}})}
                                                 onChangeName={(name) =>
                                                    setVipConfig({...vipConfig, vip: {...vipConfig.vip, name}})}
                                        />
                                        <VIPForm initName={vipConfig?.vvip.name}
                                                 initTotalPoint={vipConfig?.vvip.totalPoint}
                                                 initNumPoint={vipConfig?.vvip.numPoint}
                                                 initRate={vipConfig?.vvip.rate}
                                                 initUsed={vipConfig?.vvip.used}
                                                 onChangeTotalPoint={(totalPoint) =>
                                                     setVipConfig({...vipConfig, vvip: {...vipConfig.vvip, totalPoint}})}
                                                 onChangeNumPoint={(numPoint) =>
                                                     setVipConfig({...vipConfig, vvip: {...vipConfig.vvip, numPoint}})}
                                                 onChangeRate={(rate) =>
                                                     setVipConfig({...vipConfig, vvip: {...vipConfig.vvip, rate}})}
                                                 onChangeUsed={(used) =>
                                                     setVipConfig({...vipConfig, vvip: {...vipConfig.vvip, used}})}
                                                 onChangeName={(name) =>
                                                    setVipConfig({...vipConfig, vvip: {...vipConfig.vvip, name}})}
                                        />
                                    </div>
                                )
                            }
                        </div>
                    </InputGroup>
                    <InputGroup label="포인트 조건">
                        <div className="flex-col gap-2">
                            <div className="flex-align-center gap-4">
                                <div>최소</div>
                                <div>
                                    <TextInput type="number" value={minPoint}
                                               onChange={(e) => setMinPoint(e.target.value)}
                                    />
                                </div>
                                <div>포인트 이상 사용 가능</div>
                            </div>
                            <div className="flex-align-center gap-4">
                                <div>1회 적립 시 최대</div>
                                <div>
                                    <TextInput type="number" value={maxPoint}
                                               onChange={(e) => setMaxPoint(e.target.value)}
                                    />
                                </div>
                                <div>포인트 까지 적립 가능</div>
                            </div>
                        </div>
                    </InputGroup>
                    <InputGroup label="포인트 소멸 기한" description="포인트 소멸 기한을 사용할 경우 소멸 기한이 알림톡에 추가됩니다.">
                        <div className="flex-col gap-2">
                            <div>포인트 소멸 기한은 변경된 시점 이후 건만 적용 됩니다.</div>
                            <div className="text-red-500">기존 고객들의 포인트 소멸 기한을 변경하시려면 오모플레이에 문의 해주세요.</div>
                            <div className="flex-align-center gap-4">
                                <RadioGroup items={[{label: "미사용", value: "unused"}, {label: "사용", value: "used"}]}
                                            key={usedExpiredMonth}
                                            initChecked={usedExpiredMonth ? "used" : "unused"}
                                            onSelected={(value) => {
                                                setUsedExpiredMonth(value === "used")
                                                setExpiredMonth(value === "used" ? usedExpiredMonth : null)
                                            }} />
                                {
                                    usedExpiredMonth && (
                                        <div className="flex-align-center gap-2">
                                            <div className="w-[100px]">
                                                <TextInput value={expiredMonth}
                                                           type="number"
                                                           onChange={(e) => {
                                                               setExpiredMonth(e.target.value)
                                                           }} />
                                            </div>
                                            <div>개월</div>
                                            {
                                                Number(expiredMonth) < 3 && (<div className="text-red-500">3개월 미만으로 적용할 수 없습니다.</div>)
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </InputGroup>
                </div>
                <div className="flex justify-end">
                    <Button variants="primary" size="large" value="저장하기" style={{width: "160px"}}
                            disabled={(isNew && !selectedBenefitId) || (usedExpiredMonth && Number(expiredMonth) < 3)}
                            onClick={() => {
                                // 선택된 방식의 입력값만 보낸다. 서버 DTO 는 `defaultPoint: Float`(non-null) 라
                                // 빈 값을 보내면 파싱에서 실패하므로 여기서 막는다.
                                const defaultPoint = pointType === "rate" ? rateInput : staticPointInput
                                if (defaultPoint === "" || defaultPoint == null || Number.isNaN(Number(defaultPoint))) {
                                    alert(pointType === "rate" ? "적립율을 입력해주세요." : "고정 포인트를 입력해주세요.")
                                    return
                                }
                                /*
                                  🔧 등급 값이 비어 있으면 저장을 막는다 (2026-08-27).

                                  ⚠️ **위 `gradeWarnings`(정책 경고)와는 다른 성질이다.** 적립율 역전 같은
                                     정책 문제는 "설정한 대로 동작" 이 맞으니 경고만 하고 저장을 허용한다.
                                     반면 **빈 값은 서버에서 파싱 자체가 깨진다** — `VIPConfig.Condition` 의
                                     `totalPoint: Int`·`numPoint: Int`·`rate: Float` 이 전부 non-null 이라
                                     빈 문자열을 보내면 Jackson 역직렬화 실패로 저장이 실패한다.
                                     그대로 두면 원인 모를 오류만 보게 되므로 어느 등급이 문제인지 알려준다.
                                */
                                if (usedVipConfig) {
                                    const invalidGrade = GRADE_ORDER
                                        .map((key) => vipConfig?.[key])
                                        .filter((t) => t && (t.used ?? true))
                                        .find((t) => [t.rate, t.totalPoint, t.numPoint]
                                            .some((v) => v === "" || v == null || Number.isNaN(Number(v))))
                                    if (invalidGrade) {
                                        alert(`'${invalidGrade.name}' 등급의 적립율·총 획득 포인트·총 적립 횟수를 모두 입력해주세요.`)
                                        return
                                    }
                                }
                                saveConfig(defaultPoint, pointType, selectedBenefitId, isNew, minPoint,
                                    usedVipConfig, vipConfig, expiredMonth, maxPoint,
                                    (usedEventPoint ? eventPoint : null))
                                    .then(() => {
                                        alert("저장 되었습니다")
                                    })
                            }} />
                </div>
            </div>
            <EntryPointPreviewPopup show={showQrPreview} spotId={selectedEntryPointId} onClose={() => setShowQrPreview(false)} />
            <SuspensePopup title={"혜택 연결하기"} visible={isOpenBenefitPopup}
                           onClose={() => setOpenBenefitPopup(false)}
            >
                <BenefitForm
                    onSelectedBenefit={(benefitId) => {
                        setSelectedBenefitId(benefitId)
                        setOpenBenefitPopup(false)
                    }}
                />
            </SuspensePopup>
        </>
    )
}

export default PointConfiguration